import { RegisteredComponent } from "@builder.io/sdk-react";

export const filterSearchBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Filter search",
  canHaveChildren: false,
  noWrap: true,
  defaultStyles: {
    width: "100%",
    flexShrink: "1",
    outline: "none",
  },
  inputs: [
    {
      name: "value",
      type: "string",
      localized: false,
    },
    {
      name: "onChange",
      type: "javascript",
      localized: false,
    },
    {
      name: "onSearch",
      type: "javascript",
      localized: false,
    },
    {
      name: "placeholder",
      type: "string",
      localized: true,
      required: false,
    },
    {
      name: "helperText",
      type: "string",
      localized: true,
      required: false,
      helperText: "The helper text is displayed as a first disabled option.",
    },
    {
      name: "hideSuggestions",
      type: "boolean",
      defaultValue: false,
      helperText: "When enabled, the suggestion dropdown is hidden.",
    },
    {
      name: "maxSuggestions",
      type: "number",
      required: false,
      helperText:
        "Maximum number of suggestions to display. Leave empty to show all.",
    },
    {
      name: "searchIconAriaLabel",
      type: "string",
      localized: true,
      required: false,
      helperText: "ARIA label for the search icon.",
    },
    {
      name: "resetSearchIconAriaLabel",
      type: "string",
      localized: true,
      required: false,
      helperText: "ARIA label for the reset search icon.",
    },
  ],
};
